import React, { ClassAttributes, HTMLAttributes } from 'react'
import { useState } from 'react'
import ReactMarkdown, { ExtraProps } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'
import codeBlock from '../../utils/codeWrapper'
import styles from './readmeSection.module.scss'
import CollapseHeader from './collapseHeader';

function ReadmeSection({ section }: { section: ReadmeSection }) {
    const [collapsed, setCollapsed] = useState(false)
    const sectionWithoutBrokenLinks = section.content
    return (
        <div className={styles.readmeSection}>
            <CollapseHeader
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                headerTag={section.header}
            />
            {!collapsed && (
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw, rehypeSanitize]}
                    components={{
                        pre(
                            props: ClassAttributes<HTMLElement> &
                                HTMLAttributes<HTMLElement> &
                                ExtraProps
                        ) {
                            return codeBlock(props)
                        }
                    }}
                >
                    {sectionWithoutBrokenLinks}
                </ReactMarkdown>
            )}
        </div>
    )
}

export default ReadmeSection
